export default "__VITE_ASSET__0b77c0bc__"